import {Vendor, EvidonVendor} from '../service/vendor-list'

export const fromEvidonVendor = (evidonVendor: EvidonVendor): Vendor => ({
  featureIds: [],
  id: evidonVendor.id,
  legIntPurposeIds: [],
  name: evidonVendor.companyName,
  policyUrl: (
    evidonVendor
      .optout
      .find(policy => policy.type === 0) ||
    evidonVendor.optout[0]
  ).optout_url,
  purposeIds: []
})
